import React from 'react';
import Fade from 'react-reveal/Fade';
import { useStaticQuery, graphql } from 'gatsby';
import { openModal, closeModal } from '@redq/reuse-modal';
import Text from 'src/common/components/Text';
import Button from 'src/common/components/Button';
import Heading from 'src/common/components/Heading';
import Container from 'src/common/components/UI/Container';
import BannerWrapper, {
  BannerContent,
  ButtonGroup,
  VideoWrapper,
  CustomerWrapper,
  ImageWrapper,
} from './banner.style';
import Widget from "rasa-webchat";
import Link from 'src/common/components/Link';
import Image from 'src/common/components/Image';

// close button for modal
const CloseModalButton = () => (
  <Button
    className="modalCloseBtn"
    variant="fab"
    onClick={() => closeModal()}
    icon={<i className="flaticon-plus-symbol" />}
  />
);

const ModalContent = () => (
  <VideoWrapper>
    <iframe
      title="Video"
      src="https://www.youtube.com/embed/hW98BFnVCm8"
      frameBorder="0"
    />
  </VideoWrapper>
);

const Banner = () => {
  const data = useStaticQuery(graphql`
  query {
    appChristmasJson {
      client {
        id
        title
        image {
          publicURL
        }
      }
    }
  }
`);

  const { client } = data.appChristmasJson;
  const isBrowser = typeof window !== "undefined"
  // modal handler

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      try {
        // @ts-ignore
        // eslint-disable-next-line
        document.querySelector(".rw-send").click();
      } catch (e) {
        console.log(e);
      }
    }
  };


  return (
    <BannerWrapper id="home">
      <Container>
        <BannerContent>
          <Fade up delay={100}>
            <Heading
              as="h1"
              content="Hola, ayúdame a convertirme en la mejor asistente 🥰"
            />
          </Fade>
          <Fade up delay={200}>
            <Text content="Soy Jasmine, una asistente desarrollada con inteligencia artificial que busca ofrecer las mejores experiencias de compra digital. Necesito de tu ayuda para así mejorar mis habilidades y convertirme en la mejor asistente. Siéntete libre en escribirme!" />
          </Fade>
          <Fade up delay={200} >
            <Text style={{ marginTop: "20px", color: "#fff" }} fontWeight={'500'} content=" Presiona la estrellita para empezar!" />
          </Fade>
          <Fade up delay={300}>
            <ButtonGroup>
              <Link href="/" style={{ marginTop: '-5px' }}>
                <Button className="primary" title="¿Quién es Jasmine?" />
              </Link>
            </ButtonGroup>
          </Fade>
          <Text style={{ marginTop: "30px", color: "#000000", fontSize: "12px"}} fontWeight={'600'} content="Proyecto de Investigación: Xavier Iván Aguas Haro" />
          <Text style={{ marginTop: "-15px", color: "#000000", fontSize: "12px"}} fontWeight={'100'} content="Soportado: Escuela Politécnica Nacional & JRTEC" />
          {/* <div style={{ 'alignItems': 'center', 'flexDirection': 'row', 'marginTop': '10px', display:'flex' }}>
            <div>
              <Text content="Soportado:" />
            </div>
            <div style={{ 'marginTop': '10px' }}>
              <ImageWrapper>
                {client.map((item) => (
                  <Image
                    key={`client-key${item.id}`}
                    src={item.image.publicURL}
                    alt={item.title}
                    style={{ width: '14%' }}
                  />
                ))}
              </ImageWrapper>
            </div>
          </div> */}
        </BannerContent>
        {isBrowser &&
          <div onKeyDown={handleKeyDown}>
            <Widget
              socketUrl={"https://assistant.xavieraguas.com"}
              socketPath={"/socket.io/"}
              customData={{ language: "es" }} // arbitrary custom data. Stay minimal as this will be added to the socket
              title={"Jasmine"}
              subtitle={"Asistente de Compras"}
              profileAvatar={"https://res.cloudinary.com/ecommercejasmine/image/upload/v1641417625/jasmine_ztyzdf.png"}
              embedded={false}
              inputTextFieldHint={"Escribe un mensaje..."}
              showFullScreenButton={true}
              openLauncherImage={"https://res.cloudinary.com/ecommercejasmine/image/upload/v1642126172/favicon_mrzspe.gif"}
              params={{
                images: {
                  dims: {
                    width: 300,
                    height: 230
                  }
                }
              }}
            />
          </div>
        }
      </Container>
    </BannerWrapper>
  );
};

export default Banner;
